import React, { useState, useEffect } from 'react';
import themeFilterMappingApi from '@services/themeFilterMappingApi.jsx';

const ThemeFilterSelectionModal = ({ 
    themeId, 
    availableFilters = [], 
    onClose, 
    onSave, 
    isEditMode = false, 
    initialData = null 
}) => {
    const VITE_ADMIN_BACKEND_API_URL = import.meta.env.VITE_ADMIN_BACKEND_API_URL;
    // 상태 관리
    const [selectedFilterId, setSelectedFilterId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedFilterInfo, setSelectedFilterInfo] = useState(null);

    // 초기 데이터 설정 (수정 모드)
    useEffect(() => {
        if (isEditMode && initialData) {
            console.log('수정 모드 초기 데이터:', initialData);
            
            setSelectedFilterId(initialData.photoFilterId);
            
            // 수정 모드에서는 현재 선택된 필터 정보를 직접 사용
            if (initialData.photoFilter) {
                setSelectedFilterInfo({
                    id: initialData.photoFilter.id,
                    filterName: initialData.photoFilter.filterName,
                    isActive: initialData.photoFilter.isActive,
                    filterDataResourceId: initialData.photoFilter.filterDataResourceId
                });
            } else {
                // availableFilters에서 찾기 시도
                const filterInfo = availableFilters.find(filter => filter.id === initialData.photoFilterId);
                if (filterInfo) {
                    setSelectedFilterInfo(filterInfo);
                }
            }
        }
    }, [isEditMode, initialData, availableFilters]);

    // 디버깅을 위한 상태 추적
    useEffect(() => {
        console.log('ThemeFilterSelectionModal - 현재 상태:', {
            selectedFilterId,
            selectedFilterInfo,
            availableFilters: availableFilters.map(filter => ({
                id: filter.id,
                filterName: filter.filterName,
                filterDataResourceId: filter.filterDataResourceId,
                필터명있는지: filter.filterName ? 'YES' : 'NO',
                이미지있는지: filter.filterDataResourceId ? 'YES' : 'NO'
            })),
            availableFiltersLength: availableFilters.length
        });
    }, [selectedFilterId, selectedFilterInfo, availableFilters]);

    // 필터 선택 핸들러
    const handleFilterSelect = (filterId) => {
        setSelectedFilterId(filterId);
        const filterInfo = availableFilters.find(filter => filter.id === filterId);
        setSelectedFilterInfo(filterInfo);
    };



    // 저장 핸들러
    const handleSave = async () => {
        if (!selectedFilterId) {
            alert('필터를 선택해주세요.');
            return;
        }

        setIsLoading(true);
        try {
            let result;
            
            if (isEditMode) {
                // 수정 모드
                result = await themeFilterMappingApi.updateThemeFilterMapping(
                    initialData.mappingId, 
                    {}
                );
            } else {
                // 추가 모드
                result = await themeFilterMappingApi.addFilterToTheme(
                    themeId,
                    selectedFilterId,
                    {}
                );
            }

            onSave(result);
            onClose();
        } catch (error) {
            console.error('저장 실패:', error);
            alert(`저장 중 오류가 발생했습니다: ${error.message}`);
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <>
            <div className="modal-overlay active">
                <div className="modal-container theme-filter-modal">
                    <div className="modal-header">
                        <h3 className="modal-title">
                            테마 필터 {isEditMode ? '수정' : '선택'}
                        </h3>
                        <button className="modal-close" onClick={onClose}>
                            <i className="ri-close-line"></i>
                        </button>
                    </div>
                    
                    <div className="modal-body">
                        <div className="modal-content">
                            {/* 필터 선택 섹션 (추가 모드에서만) */}
                            {!isEditMode && (
                                <div className="modal-form-group">
                                    <label className="modal-label">필터 선택</label>
                                    {availableFilters.length === 0 ? (
                                        <div className="no-filters-message">
                                            사용 가능한 필터가 없습니다.
                                        </div>
                                    ) : (
                                        <div className="filter-selection-grid">
                                            {availableFilters.map((filter) => {
                                                console.log('각 필터 상세 데이터:', {
                                                    id: filter.id,
                                                    filterName: filter.filterName,
                                                    filterDataResourceId: filter.filterDataResourceId,
                                                    전체객체: filter
                                                });
                                                return (
                                                    <div 
                                                        key={filter.id}
                                                        className={`filter-selection-item ${selectedFilterId === filter.id ? 'selected' : ''}`}
                                                        onClick={() => handleFilterSelect(filter.id)}
                                                    >
                                                        <div className="filter-info">
                                                            <h4>{filter.filterName || '필터명 없음'}</h4>
                                                            <div className="filter-preview">
                                                                {filter.filterDataResourceId ? (
                                                                    <img 
                                                                        src={`${VITE_ADMIN_BACKEND_API_URL}/resource/view/${filter.filterDataResourceId}`} 
                                                                        alt={filter.filterName || '필터 이미지'}
                                                                        // onError={(e) => {
                                                                        //     console.log('이미지 로드 실패:', e.target.src);
                                                                        //     e.target.src = '/images/filterData/filter1.png';
                                                                        // }}
                                                                        onLoad={() => {
                                                                            console.log('이미지 로드 성공:', filter.filterName);
                                                                        }}
                                                                    />
                                                                ) : (
                                                                    <div className="no-image-placeholder">
                                                                        <i className="ri-image-line"></i>
                                                                        <span>이미지 없음</span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                        </div>
                                    )}
                                </div>
                            )}

                            {/* 선택된 필터 정보 표시 */}
                            {selectedFilterInfo && (
                                <div className="modal-form-group">
                                    <label className="modal-label">선택된 필터 정보</label>
                                    <div className="selected-filter-info">
                                        <div className="filter-details">
                                            <h4>{selectedFilterInfo.filterName}</h4>
                                        </div>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                    
                    <div className="modal-footer">
                        <button 
                            className="modal-btn modal-btn-cancel" 
                            onClick={onClose}
                            disabled={isLoading}
                        >
                            취소
                        </button>
                        <button 
                            className="modal-btn modal-btn-primary" 
                            onClick={handleSave}
                            disabled={isLoading || (!isEditMode && !selectedFilterId)}
                        >
                            {isLoading ? '저장 중...' : (isEditMode ? '수정' : '추가')}
                        </button>
                    </div>
                </div>
            </div>

            <style>{`
                .theme-filter-modal {
                    max-width: 800px;
                    width: 90%;
                    animation: none !important;
                    transform: none !important;
                }

                .filter-selection-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
                    gap: 15px;
                    margin-top: 10px;
                }

                .filter-selection-item {
                    border: 2px solid #e0e0e0;
                    border-radius: 8px;
                    padding: 15px;
                    cursor: pointer;
                    transition: all 0.3s ease;
                    background: #fff;
                    min-height: 200px;
                    display: flex;
                    flex-direction: column;
                }

                .filter-selection-item:hover {
                    border-color: #007bff;
                    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.2);
                }

                .filter-selection-item.selected {
                    border-color: #007bff;
                    background: #f8f9ff;
                    box-shadow: 0 2px 8px rgba(0, 123, 255, 0.3);
                }

                .filter-info {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                }

                .filter-info h4 {
                    margin: 0 0 10px 0;
                    font-size: 16px;
                    font-weight: 600;
                    color: #333;
                    text-align: center;
                }

                .filter-preview {
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .filter-preview img {
                    max-width: 100%;
                    max-height: 120px;
                    object-fit: contain;
                    border-radius: 4px;
                    background-color: #f5f5f5;
                }

                .selected-filter-info {
                    background: #f8f9fa;
                    border: 1px solid #dee2e6;
                    border-radius: 6px;
                    padding: 15px;
                }

                .filter-details h4 {
                    margin: 0;
                    font-size: 18px;
                    color: #333;
                }

                .no-filters-message {
                    text-align: center;
                    padding: 40px 20px;
                    color: #666;
                    font-size: 16px;
                    background: #f8f9fa;
                    border: 1px solid #dee2e6;
                    border-radius: 6px;
                    margin-top: 10px;
                }

                .no-image-placeholder {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    height: 120px;
                    color: #999;
                    background: #f8f9fa;
                    border: 2px dashed #ddd;
                    border-radius: 4px;
                }

                .no-image-placeholder i {
                    font-size: 24px;
                    margin-bottom: 5px;
                }

                .no-image-placeholder span {
                    font-size: 12px;
                }
            `}</style>
        </>
    );
};

export default ThemeFilterSelectionModal;